import { find, get } from 'lodash';

import constants from '../constants';

const UDF_PATHS = [
  'customData.CS.userDefined.ticket',
  'customData.CS.userDefined.order',
  'customData.CS.userDefined.plant',
];

const normalizeUserDefinedEntries = raw => {
  if (Array.isArray(raw)) {
    return raw;
  }

  if (raw && typeof raw === 'object') {
    return Object.values(raw);
  }

  return [];
};

export class CustomSecuenceData {
  constructor() {
    this.next = null;
  }

  setNext(handler) {
    this.next = handler;

    return handler;
  }

  getSequenceDataValue(context, fieldPrompt) {
    for (const path of UDF_PATHS) {
      const userDefinedData = get(context, path, {});
      const entries = normalizeUserDefinedEntries(userDefinedData);
      const found = find(entries, { field: fieldPrompt });

      if (found?.value !== undefined && found?.value !== null && found?.value !== '') {
        return found.value;
      }
    }

    return '';
  }

  handle(params) {
    const { token, context } = params;

    if (token.includes(`${constants.ORDER_CODE}`)) {
      return this.getSequenceDataValue(context, 'OrderCode');
    }

    if (token.includes(`${constants.SEQUENCE}`)) {
      return this.getSequenceDataValue(context, 'Sequence');
    }

    if (token.includes(`${constants.SUPER_P_TYPE}`)) {
      return this.getSequenceDataValue(context, 'SuperPType');
    }

    if (token.includes(`${constants.MILL_CERTIFICATION}`)) {
      return this.getSequenceDataValue(context, 'MillCertification');
    }

    return this?.next?.handle?.(params);
  }
}
